import { Link, router } from '@inertiajs/react'

export default function Show({ cart }) {
  const csrfToken = () =>
    document.querySelector('[name="csrf-token"]')?.content || ''

  const handleRemove = async (itemId) => {
    await fetch(`/web_carts/${cart.id}/items/${itemId}`, {
      method: 'DELETE',
      headers: { 'X-CSRF-Token': csrfToken() }
    })
    router.reload()
  }

  const handleCheckout = () => {
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/checkouts'
    const cartInput = document.createElement('input')
    cartInput.type = 'hidden'; cartInput.name = 'cart_id'; cartInput.value = cart.id
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'; csrfInput.name = 'authenticity_token'; csrfInput.value = csrfToken()
    form.appendChild(cartInput); form.appendChild(csrfInput)
    document.body.appendChild(form); form.submit()
  }

  const total = cart.subtotal ? Number(cart.subtotal).toFixed(2) : '0.00'

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Nav */}
        <div className="flex items-center justify-between mb-8">
          <Link href="/" className="text-blue-600 hover:text-blue-800">← Offers</Link>
          <div className="flex gap-3">
            <Link href="/wallet" className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg">
              Wallet
            </Link>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-6">Your Cart</h1>

        {cart.items.length === 0 ? (
          <div className="bg-white rounded-xl shadow p-8 text-center text-gray-500">
            Your cart is empty.
            <div className="mt-4">
              <Link href="/" className="text-blue-600 hover:text-blue-800">Browse Offers</Link>
            </div>
          </div>
        ) : (
          <>
            <div className="bg-white rounded-xl shadow overflow-hidden mb-6">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">Item</th>
                    <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Price</th>
                    <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Qty</th>
                    <th className="text-right py-3 px-4 text-sm font-semibold text-gray-600">Total</th>
                    <th className="py-3 px-4" />
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {cart.items.map((item) => (
                    <tr key={item.id}>
                      <td className="py-4 px-4">
                        <p className="font-medium text-gray-900">{item.name}</p>
                        <p className="text-xs text-gray-400 capitalize">{item.item_type}</p>
                      </td>
                      <td className="py-4 px-4 text-right text-gray-700">
                        {Number(item.unit_price).toFixed(2)} vuu
                      </td>
                      <td className="py-4 px-4 text-right text-gray-700">{item.quantity}</td>
                      <td className="py-4 px-4 text-right font-semibold text-gray-900">
                        {Number(item.line_total).toFixed(2)} vuu
                      </td>
                      <td className="py-4 px-4 text-right">
                        <button
                          onClick={() => handleRemove(item.id)}
                          className="text-red-500 hover:text-red-700 text-sm"
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Summary */}
            <div className="bg-white rounded-xl shadow p-6">
              <div className="flex justify-between text-xl font-bold text-gray-900 mb-2">
                <span>Subtotal</span>
                <span>{total} vuu</span>
              </div>
              <p className="text-sm text-gray-500 mb-6">Settlement currency: vuuCoin (vuu)</p>

              <div className="flex gap-3">
                {cart.offer_id && (
                  <Link
                    href={`/menus/${cart.offer_id}`}
                    className="flex-1 text-center bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-4 rounded-lg"
                  >
                    ← Continue Shopping
                  </Link>
                )}
                <button
                  onClick={handleCheckout}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg"
                >
                  Proceed to Checkout →
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
